import { render, staticRenderFns } from "./BulkItems.vue?vue&type=template&id=01981ce4"
import script from "./BulkItems.vue?vue&type=script&lang=js"
export * from "./BulkItems.vue?vue&type=script&lang=js"
import style0 from "./BulkItems.vue?vue&type=style&index=0&id=01981ce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports